import repository from "../Repository";

export default {
  async entry(screenId, payload) {
    return await repository.post(`nems/equipment-deploy-entry`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        s: screenId
      }
    });
  }
};
